import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIsAddPhotoWidgetOpen } from '@/store/slices/progressSlice';
import { path } from '@/routes/Routes.helpers';
import { useClothingByParentCategories } from '@/hooks/useClothingByParentCategories';
import IcoStars from '@/assets/svg/ico_stars.svg?react';
import Button from '@/components/controls/Button/Button.component';
import EmptyWardrobeInfoModal from '@/components/elems/EmptyWardrobeInfoModal/EmptyWardrobeInfoModal.component';
import styles from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.module.scss';
import { TabBarWidgetMenuPropsIF } from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.types';

const TabBarWidgetMenu: FC<TabBarWidgetMenuPropsIF> = ({ isNeedHighlight }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { categoriesData } = useClothingByParentCategories();

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const clickHandler = (): void => {
        if (categoriesData) {
            navigate(path('outfitsCreate'));
            return;
        }

        setIsModalOpen(true);
    };

    return (
        <>
            <Button
                dataTest="button_open_menu"
                isCustom
                className={`flc ${styles.centerBtn} ${isNeedHighlight ? 'tourStepButton' : ''}`}
                clickHandler={clickHandler}
            >
                <IcoStars />
            </Button>

            {isModalOpen && (
                <EmptyWardrobeInfoModal
                    onClose={() => setIsModalOpen(false)}
                    openPhotoWidget={() =>
                        dispatch(setIsAddPhotoWidgetOpen(true))
                    }
                />
            )}
        </>
    );
};

export default TabBarWidgetMenu;
